//user login authentication
export const POST_LOGIN = "api/auth/signin";
export const POST_NEW_PASSWORD = "api/auth/new-password";
export const POST_PASSWORD_FORGET = (username) =>
  `api/auth/forgot-password/${username}`;
export const POST_CHANGE_PASSWORD = (id) => `api/auth/changes-pass/${id}`;
export const RESET_TOKEN = "api/refresh/refreshtoken";
export const UPDATE_ADMIN_PROFILE_SM = "api/auth/update-admin-info";

//tax master
export const GET_TAX_LIST = "api/tax/tax-list";
export const POST_TAX_MASTER = "api/tax";
export const DELETE_TAX_MASTER = (id) => `api/tax/${id}`;
export const PUT_TAX_MASTER = "api/tax";
export const PUT_TAX_STATUS = (id) => `api/tax/tax-action/${id}`;

//customers
export const GET_ALL_CUSTOMERS = "api/user/customer-list";
export const ADD_CUSTOMER = "api/user";
export const DELETE_CUSTOMER = (id) => `api/user/${id}`;
export const EDIT_CUSTOMER = (id) => `api/user/${id}`;

//suppliers
export const GET_ALL_SUPPLIERS = "api/suppliers/supplier-list";
export const POST_SUPPLIER = "api/suppliers";
export const DELETE_SUPPLIER = (id) => `api/suppliers/${id}`;
export const EDIT_SUPPLIER = "api/suppliers";

//vehicle
export const GET_ALL_VEHICLE = "api/vehicle/vehicle-list";
export const POST_VEHICLES = "api/vehicle";
export const DELETE_VEHICLES = (id) => `api/vehicle/${id}`;
export const PUT_VEHICLE = "api/vehicle";

//sessions

export const GET_ALL_SESSIONS = "api/session/session-list";
export const ADD_SESSIONS = "api/session";
export const DELETE_SESSION = (id) => `api/session/${id}`;
export const EDIT_SESSION = "api/session";
export const PUT_SESSION_STATUS = (id) => `api/session/session-action/${id}`;

//trips
export const GET_ALL_TRIPS = "api/daily-trip/dailytrip-list";
export const POST_BOOKED_TRIP = "api/daily-trip";
export const DELETE_BOOKED_TRIP = (id) => `api/daily-trip/${id}`;
export const PUT_BOOKED_TRIP = "api/daily-trip";

//bill Invoice gst
export const GET_ALL_BILL_INVOICE = "api/bill-invoice/invoice-list";
export const POST_BILL_INVOICE = "api/bill-invoice";
export const DELETE_BILL_INVOICE = (id) => `api/bill-invoice/${id}`;
export const GET_BILL_BY_ID = (id) => `api/bill-invoice/${id}`;
export const PUT_BILL_INVOICE = (id) => `api/bill-invoice/${id}`;
export const DOWNLOAD_PDF = (id) => `api/bill-invoice/generate-bill/${id}`;
export const PUT_NOTE = (id) => `api/bill-invoice/note/${id}`;
export const PUT_BILL_INVOICE_STATUS = (id, status) =>
  `api/bill-invoice/payment-action/${id}?paymentAction=${status}`;

export const DOWNLOAD_LEDGER = "api/customer-ledger";

//bill invoice charges
export const GET_ALL_INVOICE_CHARGES = "api/bill-charges-invoice/invoice-list";
export const POST_INVOICE_CHARGES = "api/bill-charges-invoice";
export const DELETE_INVOICE_CHARGES = (id) => `api/bill-charges-invoice/${id}`;
export const PUT_INVOICE_CHARGES = (id) => `api/bill-charges-invoice/${id}`;
export const GET_EXTRA_BILL_BY_ID = (id) => `api/bill-charges-invoice/${id}`;
export const DOWNLOAD_CHARGES_PDF = (id) =>
  `api/bill-charges-invoice/generate-bill/${id}`;

export const PUT_CHARGES_NOTE = (id) => `api/bill-charges-invoice/note/${id}`;
export const PUT_CHARGES_PAYMENT_STATUS = (id, status) =>
  `api/bill-charges-invoice/payment-action/${id}?paymentAction=${status}`;

//reports
export const GET_DAILY_REPORT = "api/excel-export/daily-trip";
export const GET_DAILY_GST_REPORT = "api/excel-export/bill-invoice";
export const GET_DAILY_OTHER_REPORT = "api/excel-export/charges-invoice";

//meal category
export const POST_MEAL_CATEGORY = "api/category";
export const GET_MEAL_CATEGORY = (id) => `api/category/${id}`;
export const DELETE_MEAL_CATEGORY = (id) => `api/category/${id}`;
export const GET_MEAL_CATEGORY_LIST = "api/category/category-list";
export const UPLOAD_EXCEL = "api/excel-export/import-customer-supplier";

//diet plan
export const POST_DIET_PLAN = "api/diet-plan";
// export const POST_AUTO_DIET_PLAN="api/diet-plan/auto-diet-plan"
export const GET_DIET_PLAN = (id) => `api/diet-plan/${id}`;
export const DELETE_DIET_PLAN = (id) => `api/diet-plan/${id}`;
export const GET_DIET_PLAN_LIST = "api/diet-plan/items-list";

//diet videos
export const POST_DIET_VIDEOS = "api/diet-videos";
export const GET_DIET_VIDEOS = (id) => `api/diet-videos/${id}`;
export const DELETE_DIET_VIDEOS = (id) => `api/diet-videos/${id}`;
export const GET_DIET_VIDEOS_LIST = "api/diet-videos/items-list";

//meal items
export const POST_MEAL_ITEMS = "api/meal-items";
export const GET_MEAL_ITEMS = (id) => `api/meal-items/${id}`;
export const DELETE_MEAL_ITEMS = (id) => `api/meal-items/${id}`;
export const GET_MEAL_ITEMS_LIST = `api/meal-items/items-list`;

//dietary preferences
export const POST_DIETARY_PREFERENCES = "api/dietary-preferences";
export const POST_DIETARY_PREFERENCES_LIST =
  "/api/dietary-preferences/save-list";
export const GET_DIETARY_PREFERENCES = (id) => `api/dietary-preferences/${id}`;
export const DELETE_DIETARY_PREFERENCES = (id) =>
  `api/dietary-preferences/${id}`;
export const GET_DIETARY_PREFERENCES_LIST =
  "api/dietary-preferences/preferences-list";

//Allergy
export const POST_ALLERGY = "api/allergies";
export const POST_ALLERGY_LIST = "api/allergies/save-list";
export const GET_ALLERGY = (id) => `api/allergies/${id}`;
export const DELETE_ALLERGY = (id) => `api/allergies/${id}`;
export const GET_ALLERGY_LIST = "api/allergies/allergies-list";

//otp
export const POST_VERIFY_OTP = "api/otp/verify-otp";
export const POST_SEND_OTP = "api/otp/send-otp";
export const POST_REST_PASSWORD = "api/auth/new-password";

//user
export const POST_USER = "api/user";
export const GET_USER = (id) => `api/user/${id}`;
export const DELETE_USER = (id) => `api/user/${id}`;
export const GET_USER_LIST = "api/user/user-list";
export const PUT_USER_STATUS = (id, status) =>
  `api/user/user-action/${id}?userAction=${status}`;

//subscription plan
export const POST_SUBSCRIPTION_PLAN = "api/subscription-plan";
export const GET_SUBSCRIPTION_PLAN = (id) => `api/subscription-plan/${id}`;
export const DELETE_SUBSCRIPTION_PLAN = (id) => `api/subscription-plan/${id}`;
export const GET_SUBSCRIPTION_PLAN_LIST = "api/subscription-plan/plan-list";

//banners
export const POST_BANNER = "api/banner";
export const UPDATE_BANNER = (id) => `api/banner/${id}`;
export const GET_BANNER = (id) => `api/banner/${id}`;
export const DELETE_BANNER = (id) => `api/banner/${id}`;
export const GET_BANNER_LIST = "api/banner/banner-list";

//restaurant
export const POST_RESTAURANT = "api/restaurant";
export const UPDATE_RESTAURANT = "api/restaurant";
export const GET_RESTAURANT = (id) => `api/restaurant/${id}`;
export const DELETE_RESTAURANT = (id) => `api/restaurant/${id}`;
export const GET_RESTAURANT_LIST = "api/restaurant/items-list";

//get admin profile
export const GET_ADMIN_PROFILE = () => "api/auth/admin-deatils";
export const UPDATE_ADMIN_PROFILE = "api/auth/update-admin-info";

//notifications

export const GET_NOTIFICATIONS_LIST = "api/notification";
export const POST_NOTIFICATIONS = "api/notification";
export const GET_NOTIFICATION = (id) => `api/notification/${id}`;
export const DELETE_NOTIFICATION = (id) => `api/notification/${id}`;

//terms and conditions

export const GET_TERMS_AND_CONDITIONS = "api/terms-condition";
export const POST_TERMS_AND_CONDITIONS = "api/terms-condition";

//privacy policy
export const GET_PRIVACY_POLICY = "api/privacy-policy";
export const POST_PRIVACY_POLICY = "api/privacy-policy";

//paid plans
export const GET_PAID_SUBSCRIPTION_LIST = "api/subscription/subscription-list";

//dashboard
export const DASHBOARD_DATA = "api/tenant-dashboard";
export const DASHBOARD_BILLING_DATA = (id) =>
  `api/tenant-dashboard/bill?sessionId=${id}`;
